import { atom } from "recoil";

// KP全医療機関マスタの受入実績不可の中間テーブル
export const unavailableState = atom({
  key: "unavailableState",
  default: {
    id: null,
    hospital_id: null,
    corporation_id: null,
    corporation_name: '',
    notes: '',
  },
});